import { render, staticRenderFns } from "./screen_documentoliq.vue?vue&type=template&id=3b4e8b1b"
import script from "./screen_documentoliq.vue?vue&type=script&lang=js"
export * from "./screen_documentoliq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports